import React from "react";
import {CustomLinkIcon} from "./icons/custom-link-icon";
import {CustomFacebookIcon} from "./icons/custom-facebook-icon";
import {CustomInstagramIcon} from "./icons/custom-instagram-icon";
import {CustomTwitterIcon} from "./icons/custom-twitter-icon";
import {CustomYoutubeIcon} from "./icons/custom-youtube-icon";
import {CustomPinterestIcon} from "./icons/custom-pinterest-icon";
import {CustomTikTokIcon} from "./icons/custom-tiktok-icon";
import {CustomSnapchatIcon} from "./icons/custom-snapchat-icon";
import {CustomLinkedinIcon} from "./icons/custom-linkedin-icon";
import {CustomGoodReadsIcon} from "./icons/custom-goodreads-icon";
import {CustomLubimyCzytacIcon} from "./icons/custom-lubimyczytac-icon";
import {CustomWykopIcon} from "./icons/custom-wykop-icon";

export const SocialMediaIcons: React.FC<SocialMediaIconsProps> = ({iconName}) => {

    const getIcon = () => {
        switch(iconName) {
            case 'www':
                return <CustomLinkIcon/>;
            case 'Facebook':
                return <CustomFacebookIcon/>;
            case 'Instagram':
                return <CustomInstagramIcon/>;
            case 'Twitter':
                return <CustomTwitterIcon/>;
            case 'YouTube':
                return <CustomYoutubeIcon/>;
            case 'Pinterest':
                return <CustomPinterestIcon/>;
            case 'TikTok':
                return <CustomTikTokIcon/>;
            case 'Snapchat':
                return <CustomSnapchatIcon/>;
            case 'LinkedIn':
                return <CustomLinkedinIcon/>;
            case 'GoodReads':
                return <CustomGoodReadsIcon/>;
            case 'LubimyCzytac':
                return <CustomLubimyCzytacIcon/>;
            case 'Wykop':
                return <CustomWykopIcon/>;
            case 'Inne':
                return <CustomLinkIcon/>;

            default:
                return '';
        }
    }

    return (
        <>{getIcon()}</>
    );
}

export interface SocialMediaIconsProps {
    iconName: string;
}
